<template>

	<div class="portlet box red">

		<div class="portlet-title">

			<div class="caption">
				<i class="fa fa-envelope-open" aria-hidden="true"></i>
				Mensagens não lidas
			</div>

			<div class="actions">

				<router-link to="/inbox" class="btn btn-circle btn-default">
					<i class="icon-envelope-open"></i>
					Ir para Caixa de Entrada
				</router-link>

			</div>

		</div>

		<div class="portlet-body">

			<div class="portlet m-b-0" v-for="msgGroup in messagesGroups">

				<div class="portlet-title m-b-0">

					<div class="caption">

						<i class="icon-speech"></i>

						<span class="caption-subject bold uppercase">
							Assunto: {{ msgGroup.subject }}
						</span>

					</div>

					<div class="actions">

						<button type="button" class="btn btn-circle btn-default" @click="replyMessage(msgGroup.messageGroup)">
							Responder
						</button>

					</div>

				</div>

				<div class="portlet-body p-t-0">

					<div class="table-responsive">

						<table class="table table-condensed table-striped">
							<tbody>
								<tr  v-for="(msg, index) in msgGroup.messages" v-if="index < 3">
									<td :class="{'bold': msgGroup.notRead}">{{ msg.from.name }}</td>
									<td :class="{'bold': msgGroup.notRead}">{{ msg.message | truncate(340) }}</td>
									<td :class="{'bold': msgGroup.notRead}" class="text-right">{{ msg.sentDateTime | date("DD/MM/YYYY HH:mm") }}</td>
								</tr>
							</tbody>
						</table>

					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<script>

	import Messages from './';
	export default Messages;

</script>



// WEBPACK FOOTER //
// main.vue?8d2a61d2